import { Schemas } from "../types";

export function getName(profile: Schemas["PersonalInformation"]) {
  return profile.profilename_set ? profile.profilename_set[0] : undefined;
}
